'use client';

/** 카테고리 탭바 — MO: 3·4뎁스 두 줄 / PC: 아래 뎁스 한 줄(type12 퀵메뉴) */
import { getNavigationItemValue } from '@hooks/category/useCategoryNavigationTabs';
import useGlobalState from '@hooks/useGlobalState';
import useHistoryRouter from '@hooks/useLinkTo';
import type { CategoryNavigationItem } from '@apis/renewal/categoryMain';
import MenuBarItem from '@wconcept/wconcept-ui-renewal/components/molecules/_item/MenuBarItem';
import CategoryMenuBar from '@wconcept/wconcept-ui-renewal/components/organisms/_menuBar/CategoryMenuBar';
import { useCallback, type JSX } from 'react';

interface CategoryPathTabsProps {
  readonly depth3List: CategoryNavigationItem[];
  readonly depth4List: CategoryNavigationItem[];
  readonly selectedDepth3Value?: string;
  readonly selectedDepth4Value?: string;
}

function CategoryPathTabs({
  depth3List,
  depth4List,
  selectedDepth3Value,
  selectedDepth4Value,
}: CategoryPathTabsProps): JSX.Element | null {
  const { isMobile } = useGlobalState();
  const { linkTo } = useHistoryRouter();

  const onClickItem = useCallback(
    (item: CategoryNavigationItem) => {
      if (item.landingUrl) {
        linkTo.push({ url: item.landingUrl });
      }
    },
    [linkTo]
  );

  const renderItems = (list: CategoryNavigationItem[]) =>
    list.map(item => (
      <MenuBarItem
        key={getNavigationItemValue(item)}
        value={getNavigationItemValue(item)}
        text={item.categoryName}
        onClick={() => {
          onClickItem(item);
        }}
      />
    ));

  if (!depth3List.length && !depth4List.length) {
    return null;
  }

  if (!isMobile) {
    const hasDepth4 = depth4List.length > 0;
    return (
      <div className="area-menu">
        <div className="inner-area-menu">
          <CategoryMenuBar
            type="type12"
            isDesktop
            pcWrap
            pcGap={{ colGap: 0, rowGap: 0 }}
            selectedValue={
              hasDepth4 ? selectedDepth4Value : selectedDepth3Value
            }
            items={renderItems(hasDepth4 ? depth4List : depth3List)}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="area-menu">
      <div className="inner-area-menu">
        {depth3List.length > 0 && (
          <CategoryMenuBar
            type="type9"
            selectedValue={selectedDepth3Value}
            items={renderItems(depth3List)}
          />
        )}
        {depth4List.length > 0 && (
          <CategoryMenuBar
            type="type4"
            selectedValue={selectedDepth4Value}
            items={renderItems(depth4List)}
          />
        )}
      </div>
    </div>
  );
}

export default CategoryPathTabs;
